import { snakeCase, last } from 'lodash'
import * as moment from 'moment'
import Api from '../Api'

const subscriptions = {
  namespaced: true,
  state: {
    subscriptions: [],
    count: 0,
    loading: false,
    page: 1,
    order: null,
    asc: null,
    plan: null,
    search: null,
    active: false,
    deleteSubscriptionId: null,
    deleting: false
  },
  mutations: {
    startLoading(state) {
      state.loading = true
    },
    setMetadata(state, { page, order, asc, plan, search, active }) {
      state.page = (order || asc) ? 1 : (page || state.page)
      if(order) state.order = order
      if(asc) state.asc = asc
      state.plan = plan
      state.search = search
      state.active = active
    },
    receive(state, data) {
      state.subscriptions = data.subscriptions.map(sub => ({...sub, expiresAt: moment(sub.expiresAt) }))
      state.count = data.resultCount
      state.loading = false
    },
    addNew(state, subscription) {
      subscription.expiresAt = moment(subscription.expiresAt)
      state.subscriptions.unshift(subscription)
      state.count += 1
    },
    updateExisting(state, subscription) {
      subscription.expiresAt = moment(subscription.expiresAt)
      const index = state.subscriptions.findIndex(s => s.id === subscription.id)
      state.subscriptions[index] = subscription
    },
    removeExisting(state, id) {
      state.subscriptions = state.subscriptions.filter(s => +s.id !== +id)
    },
    updateDeleteSubscription(state, id) {
      state.deleteSubscriptionId = id
    },
    cancelDeleteSubscription(state) {
      state.deleteSubscriptionId = null
    },
    deletingSubscription(state) {
      state.deleting = true
    },
    deletedSubscription(state) {
      state.deleting = false
    }
  },
  actions: {
    async fetchPage({ commit, state: { page, order, asc, plan, search, active } }, metadata = {}) {
      metadata = { page, order, asc, plan, search, active, ...metadata }

      commit('startLoading')
      commit('setMetadata', metadata)

      const { data } = await Api.get('/guestroom/subscriptions', {
        params: {
          ...metadata,
          order: snakeCase(metadata.order)
        }
      })

      commit('receive', data)
    },
    async destroySubscription({ commit }, id) {
      commit('deletingSubscription')
      const { data } = await Api.delete(`/guestroom/subscriptions/${id}`)
      commit('removeExisting', data.subscriptionId)
      commit('cancelDeleteSubscription')
      commit('deletedSubscription')
    }
  },
  getters: {
    getSubscription: (state) => (id) => {
      return state.subscriptions.find(sub => sub.id === id)
    },
    generateName: (state) => (subscription) => {
      const { companyName, subscriptionHolders, country, city } = subscription
      let name;
      let location;

      if(!companyName) {
        const user = (subscriptionHolders || '').split(',')[0]
        const companyDomain = last(user.split('@'))
        name = companyDomain.split('.')[0]
      } else {
        name = companyName.split(' ').join('')
        location = country || "worldwide"
      }

      const nameWithLocation =  `${name}${location ? ('_' + location) : ''}${city ? ('_' + city) : ''}`
      return nameWithLocation.toUpperCase()
    }
  }
}

export default subscriptions